class User {
  email: string = "";
  name: string = "";
  brand: string = "";
  brandLink: string = "";
  funnels: string = "";
  funnelsOther: string = "";
  membershipId: string = "";
  skuTotalNum: number = 0;
  clothesTotalNum: number = 0;
  userType: string = "";
  socialLoginType: string = "";
  paymentMethodId?: string;
  getPromotionCredit: boolean = false;
  isFirstLogin: boolean = false;
  imageStorageId?: string;
  profileImageUrl?: string;
  phoneNumber: string = "";
  isImageStorageWarned: boolean = false;
  isPaymentMethodWarned: boolean = false;
  membershipName: string = "";
  othercolorAvailability: boolean = false;
  mannequinTrainAvailability: boolean = false;
  isVerifiedPhone: boolean = false;
  myReferralCode: string = "";
  hasPaid: boolean = false;
  isActived : string = "";
  check_first_credit: boolean = false;
  announcement: {
    is_actived_announcement: string;
    title: string;
    content: string;
    link: string;
    version: string;
  } = {
    is_actived_announcement: "",
    title: "",
    content: "",
    link: "",
    version: "",
  };
  totalCredit?: {
    bonusCreditTotal?: number;
    paidCreditTotal?: number;
  } = {
    bonusCreditTotal: 0,
    paidCreditTotal: 0,
  };

  fromJson(response: { [x: string]: any }) {
    this.email = response["email"] ?? "";
    this.name = response["name"] ?? "";
    this.brand = response["brand"] ?? "";
    this.brandLink = response["brandLink"] ?? "";
    this.funnels = response["funnels"] ?? "";
    this.funnelsOther = response["funnelsOther"] ?? "";
    this.membershipId = response["membershipId"] ?? "";
    this.userType = response["userType"] ?? "";
    this.skuTotalNum = response["skuTotalNum"] ?? 0;
    this.clothesTotalNum = response["clothesTotalNum"] ?? 0;
    this.socialLoginType = response["socialLoginType"] ?? "";
    this.paymentMethodId = response["paymentMethodId"];
    this.getPromotionCredit = response["getPromotionCredit"] == true;
    this.isFirstLogin = response["isFirstLogin"] == true;
    this.imageStorageId = response["imageStorageId"];
    this.profileImageUrl = response["profileImageUrl"];
    this.phoneNumber = response["phoneNumber"] ?? "";
    this.isImageStorageWarned = response["isImageStorageWarned"] == true;
    this.isPaymentMethodWarned = response["isPaymentMethodWarned"] == true;
    this.membershipName = response["membershipName"] ?? "";
    this.othercolorAvailability = response["othercolorAvailability"] == true;
    this.mannequinTrainAvailability = response["mannequinTrainAvailability"] == true;
    this.isVerifiedPhone = response["isVerifiedPhone"] == true;
    this.myReferralCode = response["myReferralCode"] ?? "";
    this.isActived = response["isActived"] ?? "";
    this.check_first_credit = response["check_first_credit"] == true;
    this.announcement.is_actived_announcement = response["announcement"]["is_actived_announcement"] ?? "";
    this.announcement.title = response["announcement"]["title"] ?? "";
    this.announcement.content = response["announcement"]["content"] ?? "";
    this.announcement.link = response["announcement"]["link"] ?? "";
    this.announcement.version = response["announcement"]["version"] ?? "";
    this.hasPaid = response["hasPaid"] == true;
    if (response["total_credit"]) {
      this.totalCredit = {
        bonusCreditTotal: response["total_credit"]["bonus_credit_total"] ?? 0,
        paidCreditTotal: response["total_credit"]["paid_credit_total"] ?? 0,
      };
    }
  }
}

////////////////////////////////////////////////
////////////////////////////////////////////////
////////////////////////////////////////////////
type SkuOption = {
  sku_option_id: string;
  other_color_num: number;
  total_consuming_credit: number;
};

class Sku {
  skuId: string = "";
  gender: boolean = true;
  generateTotalNum: number = 0;
  name: string = "";
  progress: string = "unchecked"; //unchecked, checked, training, trained
  thumbnailImageUrl: string = "";
  userId: string = "";
  createdTime: Date = new Date();
  isTrainRequested: boolean = false;
  tag?: SkuTagDetail;
  sku_option?: SkuOption;
  process_time?: number;
  constructor(
    response?: { [x: string]: any },
    skuId?: string,
    gender?: boolean,
    generateTotalNum?: number,
    name?: string,
    progress?: string,
    thumbnailImageUrl?: string,
    userId?: string,
    createdTime?: Date,
    isTrainRequested?: boolean,
    process_time?: number
  ) {
    if (skuId) {
      this.skuId = skuId;
    }
    if (gender) {
      this.gender = gender;
    }
    if (generateTotalNum) {
      this.generateTotalNum = generateTotalNum;
    }
    if (name) {
      this.name = name;
    }
    if (progress) {
      this.progress = progress;
    }
    if (thumbnailImageUrl) {
      this.thumbnailImageUrl = thumbnailImageUrl;
    }
    if (userId) {
      this.userId = userId;
    }
    if (createdTime) {
      this.createdTime = createdTime;
    }
    if (isTrainRequested) {
      this.isTrainRequested = isTrainRequested;
    }
    if (response) {
      this.fromJson(response);
    }

    if (response?.sku_option) {
      this.sku_option = {
        sku_option_id: response.sku_option.sku_option_id ?? "",
        other_color_num: response.sku_option.other_color_num ?? 0,
        total_consuming_credit: response.sku_option.total_consuming_credit ?? 0,
      };
    }
    if (process_time) {
      this.process_time = process_time;
    }
  }

  fromJson(response: { [x: string]: any }) {
    this.skuId = response["skuId"] ?? "";
    this.gender = response["gender"] ?? true;
    this.generateTotalNum = response["generateTotalNum"] ?? 0;
    this.name = response["name"] ?? "";
    this.progress = response["progress"] ?? "unchecked";
    this.thumbnailImageUrl = response["thumbnailImageUrl"] ?? "";
    this.userId = response["userId"] ?? "";
    this.createdTime = new Date(response["createdTime"] ?? "");
    this.isTrainRequested = response["isTrainRequested"] ?? false;
    this.process_time = response["process_time"] ?? 0;
    if (response.tag_obj)
      this.tag = new SkuTagDetail(
        response.tag_obj.tag_id,
        response.tag_obj.tag_title,
        response.tag_obj.tag_base_color,
        response.tag_obj.tag_highlight_color
      );
  }
}

class Clothes {
  clothesId: string = "";
  skuId: string = "";
  color: string = "";
  generateNum: number = 0;
  name: string = ""; //Clothes에서 받아옴

  // constructor(response: { [x: string]: any }) {
  //   this.fromJson(response);
  // }

  fromJson(response: { [x: string]: any }) {
    this.clothesId = response["clothesId"] ?? "";
    this.skuId = response["skuId"] ?? "";
    this.color = response["color"] ?? "";
    this.generateNum = response["generateNum"] ?? 0;
    this.name = response["name"] ?? "";
  }
}

class GeneratedPhoto {
  generatedPhotoId: string = "";
  thumbnailImageUrl: string = "";
  imageUrl: string = "";
  watermarkImageUrl: string = "";
  generationId: string = "";
  clothesId: string = "";
  regeneratedPhotoNum: number = 0;
  isDownloaded: boolean = false;
  isDeleted: boolean = false;
  isLiked: boolean = false;
  isDone: boolean = false;
  timestamp: Date = new Date();

  constructor();
  constructor(data: { [x: string]: any });

  constructor(data?: { [x: string]: any }) {
    if (data !== undefined) {
      this.fromJson(data);
    }
  }

  fromJson(response: { [x: string]: any }, hasPaid: boolean = false) {
    this.generatedPhotoId = response["generatedPhotoId"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "";
    if (hasPaid) {
      // hasPaid true 일 때는 워터마크 안 뜨도록 설정 => 결제를 한 사람인지 아닌지 확인
      this.thumbnailImageUrl = this.imageUrl;
      this.watermarkImageUrl = this.imageUrl;
    } else {
      this.thumbnailImageUrl = response["thumbnailImageUrl"] ?? "";
      this.watermarkImageUrl = response["watermarkImageUrl"] ?? this.imageUrl;
    }
    this.thumbnailImageUrl = response["thumbnailImageUrl"] ?? "";
    this.watermarkImageUrl = response["watermarkImageUrl"] ?? this.imageUrl;
    this.generationId = response["generationId"] ?? "";
    this.clothesId = response["clothesId"] ?? "";
    this.regeneratedPhotoNum = response["regeneratedPhotoNum"] ?? 0;
    this.isDownloaded = response["isDownloaded"] ?? false;
    this.isDeleted = response["isDeleted"] ?? false;
    this.isLiked = response["isLiked"] ?? false;
    this.isDone = response["isDone"] ?? false;
    if ("timestamp" in response) {
      this.timestamp = new Date(response["timestamp"]);
    } else if ("generateTime" in response) {
      this.timestamp = new Date(response["generateTime"]);
    }
  }
}

class RegeneratedPhoto {
  regeneratedPhotoId: string = "";
  imageUrl: string = "";
  watermarkImageUrl: string = "";
  isDownloaded: boolean = false;
  isLiked: boolean = false;
  isDone: boolean = false;
  timestamp: Date = new Date();

  constructor();
  constructor(data: { [x: string]: any });

  constructor(data?: { [x: string]: any }) {
    if (data !== undefined) {
      this.fromJson(data);
    }
  }

  fromJson(response: { [x: string]: any }) {
    this.regeneratedPhotoId = response["regeneratedPhotoId"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "";
    this.watermarkImageUrl = response["watermarkImageUrl"] ?? this.imageUrl;
    this.isDownloaded = response["isDownloaded"] ?? false;
    this.isLiked = response["isLiked"] ?? false;
    this.isDone = response["isDone"] ?? false;
    if ("timestamp" in response) {
      this.timestamp = new Date(response["timestamp"]);
    }
  }
}

////////////////////////////////////////////////
////////////////////////////////////////////////
////////////////////////////////////////////////

class CodiItem {
  codiItemId: string = "";
  name: string = "AI 랜덤";
  nameEnglish: string = "AI Auto Generated";
  imageUrl: string = "/images/vertical-potoo-clothes.svg";
  isActive: boolean = true;

  fromJson(response: { [x: string]: any }) {
    this.codiItemId = response["codiItemId"] ?? "";
    this.name = response["name"] ?? "";
    this.nameEnglish = response["nameEnglish"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "/images/vertical-potoo-clothes.svg";
    this.isActive = response["isActive"] ?? false;
    return this;
  }
}

class Background {
  backgroundId: string = "basic";
  name: string = "기본 배경";
  nameEnglish: string = "Basic Background";
  imageUrl: string = "/images/vertical-potoo-camera.svg";
  isActive: boolean = true;

  fromJson(response: { [x: string]: any }) {
    this.backgroundId = response["backgroundId"] ?? "";
    this.name = response["name"] ?? "";
    this.nameEnglish = response["nameEnglish"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "/images/vertical-potoo-camera.svg";
    this.isActive = response["isActive"] ?? false;
    return this;
  }
}

class CameraAngle {
  poseId: string = "";
  name: string = "AI 랜덤";
  nameEnglish: string = "AI Auto Generated";
  imageUrl: string = "/images/vertical-potoo-clothes.svg";
  order: number = 0;

  fromJson(response: { [x: string]: any }) {
    this.poseId = response["poseId"] ?? "";
    this.name = response["name"] ?? "";
    this.nameEnglish = response["nameEnglish"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "/images/vertical-potoo-clothes.svg";
    this.order = response["order"] ?? 0;
    return this;
  }
}

class UploadBackground {
  backgroundId: string = "basic";
  name: string = "AI 자동 생성";
  nameEnglish: string = "AI Auto Generated";
  imageUrl: string = "/images/vertical-potoo-camera.svg";
  isActive: boolean = true;

  fromJson(response: { [x: string]: any }) {
    this.backgroundId = response["backgroundId"] ?? "";
    this.name = response["name"] ?? "";
    this.nameEnglish = response["nameEnglish"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "/images/vertical-potoo-camera.svg";
    this.isActive = response["isActive"] ?? false;
    return this;
  }
}

class Pose {
  poseId: string = "";
  name: string = "기본 포즈";
  imageUrl: string = "/images/vertical-potoo-thumbs-up.svg";
  isActive: boolean = true;

  fromJson(response: { [x: string]: any }) {
    this.poseId = response["poseId"] ?? "";
    this.name = response["name"] ?? "";
    this.imageUrl = response["imageUrl"] ?? "/images/vertical-potoo-thumbs-up.svg";
    this.isActive = response["isActive"] ?? false;
    return this;
  }
}

class SkuTagDetail {
  skuTagDetailId: string = "";
  title: string = "";
  baseColor: string = "";
  highlightColor: string = "";

  constructor(
    skuTagDetailId: string = "",
    title: string = "",
    baseColor: string = "",
    highlightColor: string = ""
  ) {
    this.skuTagDetailId = skuTagDetailId;
    this.title = title;
    this.baseColor = baseColor;
    this.highlightColor = highlightColor;
  }

  fromJson(response: { [x: string]: any }) {
    this.skuTagDetailId = response["skuTagDetailId"] ?? "";
    this.title = response["title"] ?? "";
    this.baseColor = response["baseColor"] ?? "";
    this.highlightColor = response["highlightColor"] ?? "";
    return this;
  }
}

export {
  User,
  Sku,
  Clothes,
  GeneratedPhoto,
  RegeneratedPhoto,
  CodiItem,
  Background,
  CameraAngle,
  UploadBackground,
  Pose,
  SkuTagDetail,
};
